export function formatVolume(v: number | null | undefined): string {
    if (v == null) return '$0';
    if (v >= 1e6) return `$${(v / 1e6).toFixed(1)}M`;
    if (v >= 1e3) return `$${(v / 1e3).toFixed(0)}K`;
    return `$${v.toFixed(0)}`;
}

export function formatCompactUsd(n: number): string {
    if (Math.abs(n) >= 1_000_000) return `$${(n / 1_000_000).toFixed(1)}M`;
    if (Math.abs(n) >= 1_000) return `$${(n / 1_000).toFixed(0)}k`;
    return `$${n.toFixed(0)}`;
}

export function formatSignedCompactUsd(n: number): string {
    const sign = n < 0 ? '-' : '+';
    return `${sign}${formatCompactUsd(Math.abs(n))}`;
}

export function formatSignedPercent(n: number): string {
    const sign = n < 0 ? '-' : '+';
    return `${sign}${Math.abs(n).toFixed(1)}%`;
}

export function formatDaysRemaining(endDate: string): string | null {
    const end = new Date(endDate);
    const now = new Date();
    const diffMs = end.getTime() - now.getTime();
    if (diffMs <= 0) return null;
    const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    if (days === 1) return '1 day left';
    if (days < 30) return `${days}d left`;
    const months = Math.floor(days / 30);
    if (months === 1) return '~1 month left';
    return `~${months} months left`;
}